// extracted by mini-css-extract-plugin
export default {"imageContainer":"ComponentImage_imageContainer__7wpWQ","image":"ComponentImage_image__9sDbp"};